import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 mt-4" }
const _hoisted_2 = { class: "w-full flex gap-4 justify-between" }
const _hoisted_3 = { class: "flex gap-2 items-center" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-col gap-4" }
const _hoisted_9 = { class: "flex col-span-full gap-4 mt-4" }

import {
  ref,
  reactive,
  onMounted,
  computed,
} from "vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import "v-calendar/dist/style.css";
import { DynamicProperty } from "@/models/dtos";

import MinMaxAgeInPeriod from "../validators/MinMaxAgeInPeriod.vue";
import { RangeRoot } from "@/models/forms/AgePeriod";
import RegularButton from "@/features/shared/components/ui/RegularButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SummerPeriodsEditor',
  props: {
  model: {
    type: dtos.DynamicProperty,
    required: true,
  },
  metadata: {
    type: dtos.MetaData,
    required: true,
  },
},
  emits: ["add", "remove", "labelChange", "back", "removeField", "saveItem"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const periodsWithRange = reactive(new Array<RangeRoot>());

const withoutGroup = computed(() =>
  periodsWithRange.filter((px) => px.input.type !== "periodGroup")
);

const props = __props;
const isLoaded = ref(false);
onMounted(() => {
  if (Array.isArray(props.model.data.keys)) {
    const id = props.model.data.keys[0].id;
    if (typeof id !== typeof undefined)
      props.model.data.keys = props.model.data.keys.map((x: any) => x.key);
  }
  var properties = props.metadata.properties.filter((x) =>
    props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    periodsWithRange.push(new RangeRoot(x));
  });
  isLoaded.value = true;
});

const addNewPeriod = () => {
  const newPeriod = new dtos.DynamicProperty();

  newPeriod.placeholder = "";
  newPeriod.type = "periodCheckbox";
  newPeriod.key = crypto.randomUUID();
  newPeriod.label = "";
  newPeriod.data = new dtos.PeriodProperty("", "", false);
  periodsWithRange.push(new RangeRoot(newPeriod));

  emit("add", props.model.key, newPeriod);
};

function onLabelChange(event: any) {
  emit("labelChange", event);
}

const removePeriod = (period: RangeRoot) => {
  const index = periodsWithRange.indexOf(period);
  periodsWithRange.splice(index, 1);

  emit("remove", period.input);
};

const item = ref(props.model as dtos.DynamicProperty);

const onInput = (e: dtos.AllowedAgeInPeriod) => {};
const removeAdvancedValidation = (key: string) => {};

const saveValidation = (index: number, minAge: number, maxAge: number) => {};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InputText, {
      keyId: "0",
      placeholder: item.value.label,
      label: "Rubrik för fältet",
      model: item.value.label,
      type: "text",
      onChange: onLabelChange,
      class: "col-span-full"
    }, null, 8, ["placeholder", "model"]),
    _createElementVNode("button", {
      onClick: addNewPeriod,
      class: "mt-4 col-span-full flex gap-2 items-center text-blue-1 hover:text-blue-2 cursor-pointer"
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
      _createElementVNode("span", null, "Lägg till period", -1)
    ])),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withoutGroup.value, (period, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex flex-col gap-4 bg-white ring-1 ring-orange-2 p-4 rounded-lg"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((period.Period.start) = $event),
                type: "date",
                class: "border bg-blue-4 border-gray-2 px-2 py-1 w-48 rounded focus:outline-none focus:border-blue-3",
                placeholder: "Ange startdatum"
              }, null, 8, _hoisted_4), [
                [_vModelText, period.Period.start]
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                class: "w-4 h-4 mx-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M14 5l7 7m0 0l-7 7m7-7H3"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((period.Period.end) = $event),
                type: "date",
                placeholder: "Ange slutdatum",
                class: "border bg-blue-4 border-gray-2 px-2 py-1 w-48 rounded focus:outline-none focus:border-blue-3"
              }, null, 8, _hoisted_5), [
                [_vModelText, period.Period.end]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: ($event: any) => (removePeriod(period)),
                title: "Ta bort period",
                class: "text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "Ta bort period", -1),
                _createElementVNode("i", { class: "fas fa-close" }, null, -1)
              ]), 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(MinMaxAgeInPeriod, {
              item: period.input,
              index: (index * 2).toString(),
              "period-key": period.input.key,
              onInput: onInput,
              onRemoveValidation: removeAdvancedValidation,
              onSaveValidation: saveValidation
            }, null, 8, ["item", "index", "period-key"])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(RegularButton, {
        onClick: _cache[0] || (_cache[0] = 
        () => {
          emit('removeField');
        }
      ),
        "style-type": "cancel",
        text: "Ta bort fält"
      }),
      _createVNode(RegularButton, {
        onClick: _cache[1] || (_cache[1] = 
        () => {
          emit('back');
        }
      ),
        text: "Tillbaka"
      })
    ])
  ], 64))
}
}

})